/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const NewAutoTestInitialBuildIdSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('NEW_AUTO_TEST_INITIAL_BUILD_ID')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class NewAutoTestInitialBuildIdSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return NewAutoTestInitialBuildIdSettingParser.decode(input).map(res => new NewAutoTestInitialBuildIdSetting(res));
    }
    static unsafeDecode(input) {
        return NewAutoTestInitialBuildIdSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NewAutoTestInitialBuildIdSettingParser.encode(data);
    }
    static schema() {
        return NewAutoTestInitialBuildIdSettingParser.schema();
    }
}
